export class Guid {
  static newGuid() {
    const regex = /[xy]/g;
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(regex, function(c) {
      const r = (Math.random() * 16) | 0,
        v = c === 'x' ? r : (r & 0x3) | 0x8;
      return v.toString(16);
    });
  }
}

export class StringHelper {
  public static replaceAll(target, search, replacement) {
    let result: string = target;
    let index: number = result.indexOf(search);

    while (index >= 0) {
      result = result.replace(search, replacement);
      index = result.indexOf(search, index);
    }

    return result;
  }

  public static isJSON(str): boolean {
    try {
      JSON.parse(str);
    } catch (e) {
      return false;
    }
    return true;
  }
}

export class ArrayHelper {
  public static groupBy<T>(array, key) {
    const result = [];

    for (let i = 0; i < array.length; i++) {
      const group = result.filter(x => x.key === array[i][key])[0] || { key: array[i][key], values: [] };

      if (group.values.length === 0) {
        result.push(group);
      }

      group.values.push(array[i]);
    }

    return result;
  }
}
